import React, { useEffect, useState } from 'react';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import {
  RetentionLifetimeMetricColumn,
  retentionLifetimeOptions,
} from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/RetentionCloums';
import { Table } from 'tea-component';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import {
  TableCheckboxHeader,
  TableCheckboxRender,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import FirstRowEdition from '@/pages/intelligence/components/TableComponents/components/FirstRowEdition';
import { useIntl } from 'umi';
const { pageable } = Table.addons;

const TrendsCard = (props: any) => {
  const {
    loading,
    tableData = [],
    tableTotal = 0,
    unPublishedAppIdList,
    tableSelection,
    tableSelectionAll,
    onTableCheckGame,
    onTableSortChage,
    pageSortAttr: defaultPageSortAttr,
    defaultSortDownHead,
    entityType
  } = props;

  const { formatMessage } = useIntl(); // 中英切换方法
  const [selectList, setSelectList] = useState(tableSelection);
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortAttr, setPageSortAttr] = useState(defaultPageSortAttr);

  useEffect(() => {
    onSortChage({
      sortMetric: defaultPageSortAttr?.currentSortMetric,
      sortVal: defaultPageSortAttr?.currentSortValue,
      ratioType: defaultPageSortAttr?.currentRatioType,
    })
    setPageSortAttr(defaultPageSortAttr)
  }, [tableData, defaultPageSortAttr]);

  const handleSortChange = (e: SortByItemType) => {
    onTableSortChage?.(e);
    onSortChage(e);
  }

  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e.ratioType,
    });
    const sortTable = sortTableByMetric({
      tableData: tableData,
      sortParams: e,
      timeProperty: 'date',
      metricProperty: 'name',
      growthProperty: 'dod',
    });
    setSortTableData(sortTable);
  };

  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    //DAU Revenue Download 每个数据源赋值一遍
    retentionLifetimeOptions?.forEach((t) => {
      metricCloums.push(
        RetentionLifetimeMetricColumn({
          dataSource: 'sensortower',
          title: t.title,
          // svgIcon: SensorTowerIcon,
          textContent: t?.textContent,
          key: `${t.key}`,
          metricKey: t?.metricKey || t?.key,
          sortMetric: t.key,
          currentSortValue: pageSortAttr?.currentSortValue,
          currentSortKey: `${pageSortAttr?.currentSortMetric}_${pageSortAttr?.currentRatioType}`,
          onSortChage: handleSortChange,
          entityType
        }),
      );
    });
    return metricCloums;
  };

  return (
    <>
      <Table
        //   verticalTop
        bordered="all"
        records={sortTableData}
        recordKey={'app_id'}
        className="dbi-mobileGames-details-table mobileGames-table"
        columns={[
          {
            key: 'select',
            width: 36,
            fixed: 'left',
            header: () => {
              return (
                <TableCheckboxHeader
                  selectList={selectList}
                  tableSelectionAll={tableSelectionAll}
                  disabled={loading || sortTableData?.length === 0}
                  onChange={(list, stats) => {
                    onTableCheckGame(list, stats);
                    setSelectList(list);
                  }}
                />
              );
            },
            render: (cvm: any) => {
              return (
                <TableCheckboxRender
                  selectList={selectList}
                  cvm={{ ...(cvm || {}), gameId: cvm?.app_id }}
                  onChange={(list, status) => {
                    setSelectList(list);
                    onTableCheckGame(list, status);
                  }}
                />
              );
            },
          },
          // { key: 'select', header: null, width: 50, fixed: 'left' },
          {
            key: 'id',
            header: <div className="table-header-id">#</div>,
            width: 50,
            fixed: 'left',
            render: (cvm: any) => {
              return <div>{cvm.rank}</div>;
            },
          },
          {
            key: 'app_id',
            fixed: 'left',
            width: 250,
            align: 'left',
            header: (
              <div className="stats-table-title">
                <span className="stats-table-title-text">
                  {formatMessage({ id: 'dbi_top_editions' })}
                </span>
                <span className="stats-table-title-subtext">
                  ({sortTableData?.length || 0})
                </span>
              </div>
            ),
            render: (cvm: any) => {
              const isUnPublished = unPublishedAppIdList?.includes(cvm?.app_id);
              if (cvm?.app_id === 'total') {
                return <>Total</>;
              }
              return (
                <FirstRowEdition
                  name={cvm?.name}
                  isUnPublished={isUnPublished}
                  platform={cvm?.platform}
                  imgSrc={cvm?.cover}
                />
              );
            },
          },
          ...getMetricCloums(),
        ]}
        addons={[
          pageable({
            stateTextVisible: true,
            pageSizeVisible: sortTableData?.length > 6,
            pageIndexVisible: sortTableData?.length > 6,
            jumpVisible: sortTableData?.length > 6,
            endJumpVisible: sortTableData?.length > 6,
            pageSizeOptions: [6, 10, 15],
            stateText: formatMessage(
              { id: 'dbi_pagination_total' },
              { total: sortTableData?.length ?? 0 },
            ),
          }),
        ]}
      />
    </>
  );
};

export default TrendsCard;
